module.exports = __webpack_public_path__ + "img/lens-174-minus-07.f5da6142.png";